import { GridColDef } from "@mui/x-data-grid"
// @ts-ignore
import ErrorIcon from "../../icon/error.svg?react"
import { validateLineAmountsFunction } from "./validateLineAmountsFunction"

export const addCustomFunctions = (columns: Array<GridColDef>) => {
  return columns.map((column) => {
    switch (column.field) {
      case "status":
        return {
          ...column,
          renderCell: (params) =>
            validateLineAmountsFunction(
              params.row.amount,
              params.row.quantity,
              params.row.unit_price,
            ) === "error" ? (
              <ErrorIcon style={{ color: "var(--cherry)" }} />
            ) : (
              <></>
            ),
        }

      case "purchase_order_number":
      case "purchase_order_header_status":
      case "line_number":
      case "line_status":
      case "item_description":
      case "purchase_order_unit_price":
      case "unit_measure_code":
      case "item_number":
      case "quantity_billed":
      case "quantity_received":
      case "amount_billed":
      case "amount_received":
      case "matching_basis":
      case "line_type":
      case "distribution_code":
      case "shipment_quantity":
      case "shipment_amount":
      case "shipment_number":
      case "line_purchase_order_balance":
      case "purchase_order_supplier_name":
        return {
          ...column,
          valueGetter: (params) =>
            params.row?.non_editable_po_fields
              ? params.row?.non_editable_po_fields[column.field]
              : null,
        }

      case "tax_classification_code":
        return {
          ...column,
          valueGetter: (params) => params.row?.tax_classification_code || null,
        }

      default:
        return column
    }
  })
}
